import { takeUntil } from 'rxjs/operators';
import { CompanyService } from './../../../../providers/services/company.service';
import { Component, OnInit, Input } from '@angular/core';
import { ProductBasicResponse, Company } from '@pdp/common';
import { Category } from '../../../../models/category';
import { Subject } from 'rxjs';
import { NgClass, NgFor } from '@angular/common';
import { ProductBoxTwoComponent } from '../two/product-box-two/product-box-two.component';

@Component({
    selector: 'pdp-product-list',
    templateUrl: './product-list.component.html',
    styleUrls: ['./product-list.component.scss'],
    imports: [NgClass, NgFor, ProductBoxTwoComponent]
})
export class ProductListComponent implements OnInit {

  private unsubscribe: Subject<void> = new Subject();

  public fourItems: boolean = false;
  public fiveItems: boolean = false;
  public sixItems: boolean = true;

  public company: Company;
  @Input()
  public content: ProductBasicResponse[];

  @Input()
  public category: Category;

  @Input()
  public isFeatured = false;

  constructor(public companyService: CompanyService) {}

  ngOnInit() {
    this.companyService.getValue.pipe(takeUntil(this.unsubscribe)).subscribe((company: Company)=>{
      this.company = company;
    })
  }

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
